import { render, staticRenderFns } from "./ConfirmRedemption.vue?vue&type=template&id=2f483d02&"
import script from "./ConfirmRedemption.vue?vue&type=script&lang=js&"
export * from "./ConfirmRedemption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports